import React from "react";
import clsx from "clsx";
// import * as icons from "../assets/icons";

const RepairMarkerButton = ({
  className,
  onClick,
  style,
  active,
  title,
  left,
  // onRemove,
}) => {
  return (
    <div
      //   className={["repair-type", "repair-type-non-active"]}
      className={`btn ${clsx(
        "repair-type",
        className,
        !active ? "repair-type-non-active" : "repair-type-active"
      )}`}
      style={{ cursor: "pointer", ...style }}
      onClick={onClick}
    >
      {left && (
        <div style={{ width: 50, display: "flex", justifyContent: "center" }}>
          {left}
        </div>
      )}
      <div style={{ flex: 1 }}>{title}</div>
      <div style={{ width: 160 }}>
        {active ? "กดที่ Map เพื่อปักหมุด lat/lng" : "กดเพื่อกรอกรายละเอียด"}
      </div>
      {/* {onRemove && (
        <div
          style={{
            width: 50,
            padding: "0px 10px",
            justifyContent: "flex-end",
            display: "flex",
            cursor: "pointer",
          }}
          onClick={onRemove}
        >
          <img src={icons.trashOutlined} alt="trash" />
        </div>
      )} */}
    </div>
  );
};

export default RepairMarkerButton;
